const API_BASE_URL = '/api';

export interface MetricItem {
  id: string;
  dateTime: string;
  elapsedSeconds: number;
  startTime: string;
  endTime: string;
  processName: string;
  summaryInfo: string;
  summaryAlert: string | null;
  alertSeverity: string;
  sourceTotalRecordCount: number | null;
  targetRecordCount: number | null;
  targetTotalRecordCount: number | null;
  updatedRecordCount: number | null;
  failedRecordCount: number;
}

export interface MetricsQuery {
  startDate?: string;
  endDate?: string;
  process?: string;
}

export async function getMetrics(
  query?: MetricsQuery,
  signal?: AbortSignal
): Promise<MetricItem[]> {
  const params = new URLSearchParams();

  if (query?.startDate) {
    params.append('startDate', query.startDate);
  }
  if (query?.endDate) {
    params.append('endDate', query.endDate);
  }
  if (query?.process) {
    params.append('process', query.process);
  }

  const qs = params.toString();
  const url = `${API_BASE_URL}/metrics${qs ? `?${qs}` : ''}`;
  const response = await fetch(url, { signal });

  if (!response.ok) {
    const text = await response.text().catch(() => response.statusText);
    throw new Error(`Failed to load metrics: ${text}`);
  }

  const data = await response.json();
  return data.items ?? data;
}
